import SilentRenew from './SilentRenew.component';

export default SilentRenew;
